import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    base: 'rounded-full px-4 py-3 text-sm fw-medium lh-1 ring ring-inset i-flex duration peer-focus-visible:outline-auto'
  }
} satisfies VfConfig['toggleToken']
